import { SearchspringFetcher } from "@app/scripts/lib/searchspring"
import { useSearchspringContext } from "@app/scripts/providers/searchspring"

import { useSearchspringOption } from "./use-searchspring-option"

type Options = {
  syncWithURL?: boolean
}

export function useSearchspringFilters<
  Client extends SearchspringFetcher<Response>,
  Response,
>(options: Options = {}) {
  const { syncWithURL = true } = options
  const { refine } = useSearchspringContext<Client, Response>()

  const activeFilters = useSearchspringOption("filters", {
    defaultValue: new Set<string>(),
    syncWithURL,
  })

  const handleToggleFilter = (filter: string) => {
    const filters = new Set(activeFilters)
    const targetFilters = filter.split(",")

    targetFilters.forEach((target) => {
      if (target.startsWith("ss_price")) {
        // Remove any existing ss_price filters
        for (const filter of filters) {
          if (filter.startsWith("ss_price")) {
            filters.delete(filter)
          }
        }
      }

      if (filters.has(target)) {
        filters.delete(target)
      } else {
        filters.add(target)
      }
    })

    refine("filters", filters)
  }

  const handleRemoveAllByField = (field: string) => {
    const filters = new Set(activeFilters)
    const filtersToRemove = Array.from(filters).filter((filter) =>
      filter.includes(field)
    )
    filtersToRemove.forEach((filter) => filters.delete(filter))

    refine("filters", filters)
  }

  const handleRemoveFilter = (filter: string) => {
    const filters = new Set(activeFilters)
    if (filters.has(filter)) filters.delete(filter)

    refine("filters", filters)
  }

  const handleClearFilters = () => {
    refine("filters", new Set([]))
  }

  return {
    activeFilters,
    handleToggleFilter,
    handleRemoveFilter,
    handleClearFilters,
    handleRemoveAllByField,
  }
}
